export enum VendorLabelMajors {
    SONY = 'Sony',
    UMG = 'UMG',
    WMG = 'WMG',
}
